export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20abstract%20composition%20featuring%20flowing%20organic%20curves%20in%20soft%20terracotta%20and%20cream%20tones%20blending%20into%20gentle%20sage%20green%20accents%2C%20delicate%20paper%20texture%20overlay%2C%20modern%20editorial%20background%2C%20ethereal%20diffused%20lighting%2C%20no%20people%2C%20no%20text%2C%20artistic%20gallery%20quality%2C%20serene%20and%20sophisticated%20atmosphere&width=1600&height=900&seq=kakobuy-hero-v2-01&orientation=landscape"
          alt="Kakobuy Spreadsheet Research Platform"
          title="Kakobuy Spreadsheet Research Platform"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center lg:items-start gap-10 lg:gap-16 max-w-6xl mx-auto">
          <div className="lg:w-[55%] text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/90 backdrop-blur-sm mb-6">
              <span className="w-2 h-2 rounded-full bg-accent-500"></span>
              <span className="text-xs font-medium text-foreground-700 tracking-wide uppercase">Independent Research Platform</span>
            </div>

            <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-extrabold text-background-50 leading-tight">
              The Ultimate
              <br />
              <span className="text-accent-300">Kakobuy Spreadsheet</span>
              <br />
              Resource For Smart
              <br />
              Product Research
            </h1>
          </div>

          <div className="lg:w-[45%] flex flex-col items-center lg:items-start gap-6 pt-4">
            <p className="text-base md:text-lg text-background-200 leading-relaxed max-w-md text-center lg:text-left">
              Discover thousands of trending products, verified finds, comparison guides, and spreadsheet resources to make better purchasing decisions.
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-4">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="px-8 py-3.5 rounded-xl bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
              >
                Explore Spreadsheet
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="text-background-200 text-sm font-medium hover:text-background-50 transition-colors cursor-pointer whitespace-nowrap border-b border-transparent hover:border-background-50"
              >
                Browse Latest Finds
              </a>
            </div>
            <p className="text-xs text-background-300 mt-2">
              Updated Product Research Database &bull; Independent Buying Guides &bull; Safety Focused
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}